import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { FormProvider, useForm } from 'react-hook-form';
import { apiCheckUserAuthRegisterInformation } from '../../api/userApi';
import { JoveTextFieldControlled } from '../../mui/textField/common';
import { LoadingMask } from '../../ui/Loading/LoadingMask';
import { validateIsEmail } from '../../utils/formatValidate';
import { useLocalTranslation } from '../../utils/i18nKit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var JoveAuthEnterEmailView = function JoveAuthEnterEmailView(props) {
  var className = props.className,
      continueEnter = props.continueEnter;

  var _useLocalTranslation = useLocalTranslation(),
      $t = _useLocalTranslation.$t;

  var methods = useForm({
    defaultValues: {
      email: ''
    }
  });
  var control = methods.control,
      handleSubmit = methods.handleSubmit,
      getValues = methods.getValues;

  var _useState = useState(false),
      loading = _useState[0],
      setLoading = _useState[1];
  /**
   * requests
   */


  var requestCheckUserAuthInfo = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$apiCheckUserAu, _yield$apiCheckUserAu2, res;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.next = 3;
              return apiCheckUserAuthRegisterInformation({
                email: getValues('email')
              });

            case 3:
              _yield$apiCheckUserAu = _context.sent;
              _yield$apiCheckUserAu2 = _slicedToArray(_yield$apiCheckUserAu, 1);
              res = _yield$apiCheckUserAu2[0];

              if (res) {
                continueEnter === null || continueEnter === void 0 ? void 0 : continueEnter(_objectSpread(_objectSpread({}, res.data), {}, {
                  email: getValues('email')
                }));
              } else {
                setLoading(false);
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function requestCheckUserAuthInfo() {
      return _ref.apply(this, arguments);
    };
  }();
  /**
   * methods
   */


  var validateEmailCallback = function validateEmailCallback(value) {
    return validateIsEmail(value) ? true : $t('kit:quote_send_dialog.correct_email_address');
  };

  var continueAction = function continueAction() {
    handleSubmit(requestCheckUserAuthInfo)();
  };

  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex h-full w-full items-center justify-center bg-white', className),
    children: /*#__PURE__*/_jsxs(Box, {
      sx: {
        boxShadow: '0 14px 32px rgba(20, 20, 20, 0.08)'
      },
      className: "flex w-full max-w-[400px] flex-col items-center space-y-6 rounded-2xl bg-white px-6 py-10",
      children: [/*#__PURE__*/_jsx(Box, {
        component: "img",
        src: "https://storage.googleapis.com/jove-email-templates/JoveLogo.png",
        alt: "Jove",
        className: "h-auto w-[130px]"
      }), /*#__PURE__*/_jsx(Typography, {
        className: "text-2xl font-medium leading-7 text-black",
        children: "Welcome to Jove"
      }), /*#__PURE__*/_jsx(FormProvider, _objectSpread(_objectSpread({}, methods), {}, {
        children: /*#__PURE__*/_jsxs(Box, {
          className: "w-full space-y-6",
          children: [/*#__PURE__*/_jsx(JoveTextFieldControlled, {
            name: "email",
            control: control,
            label: "Email address",
            rules: {
              validate: validateEmailCallback
            }
          }), /*#__PURE__*/_jsxs(Box, {
            className: "relative flex h-14 cursor-pointer items-center justify-center rounded bg-[#CD0D47]",
            onClick: continueAction,
            children: [loading && /*#__PURE__*/_jsx(LoadingMask, {}), /*#__PURE__*/_jsx(Typography, {
              variant: "subtitle1",
              className: "font-normal text-white",
              children: "Continue"
            })]
          })]
        })
      }))]
    })
  });
};

export default JoveAuthEnterEmailView;